.delete-modal-error-banner {
  margin-top: 12px;
}
